module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/our_services_3-9e8fe582f39a3bdc2b491d333d6087dc.jpg";